// import React, { useEffect, useState } from "react";
// import { useSearchParams } from "react-router-dom";

const PaymentStatus = () => {
  // const [searchParams] = useSearchParams();
  // const [status, setStatus] = useState(null);

  // useEffect(() => {
  //   // Example: status?payment=success or ?payment=failed
  //   const result = searchParams.get("payment");
  //   setStatus(result); // success | failed
  // }, [searchParams]);
  const status = "success";

  return (
    <div className="bg-[#fffdf7] min-h-screen flex items-center justify-center px-4">
      <div className="bg-[#fcfaec] w-full max-w-lg p-10 rounded-xl shadow-md text-center">
        {status === "success" ? (
          <>
            <h1 className="text-3xl font-bold text-green-600 mb-4">
              Payment Successful ✅
            </h1>
            <p className="text-black mb-6">
              Thank you for your payment. Your membership/payment has been
              processed successfully.
            </p>
            <a
              href="/"
              className="bg-lime-400 hover:bg-black hover:text-white text-black font-bold py-3 px-6 rounded-full transition"
            >
              Back to Home
            </a>
          </>
        ) : status === "failed" ? (
          <>
            <h1 className="text-3xl font-bold text-red-600 mb-4">
              Payment Failed ❌
            </h1>
            <p className="text-black mb-6">
              Unfortunately, your payment could not be processed. Please try
              again or contact support.
            </p>
            <a
              href="/payment"
              className="bg-lime-400 hover:bg-black hover:text-white text-black font-bold py-3 px-6 rounded-full transition"
            >
              Try Again
            </a>
          </>
        ) : (
          <h1 className="text-xl text-gray-500">Processing your payment...</h1>
        )}
      </div>
    </div>
  );
};

export default PaymentStatus;
